const PageTitle = ({ title }) => {
  return <h3 className='text-center m-0'>{title}</h3>;
};

export default PageTitle;

